import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const giftsEndPoint = '/gifts';
const userGiftsEndPoint = '/user-gifts';

export const USER_GIFT_STATUS = {
  PENDING: 'PENDING',
  UNUSED: 'UNUSED',
  USED: 'USED',
  DELIVERED: 'DELIVERED',
  RECEIVED: 'RECEIVED',
  EXPIRED: 'EXPIRED',
};

export const USER_GIFT_STATUS_LABEL = {
  [USER_GIFT_STATUS.PENDING]: 'Chờ xử lý',
  [USER_GIFT_STATUS.UNUSED]: 'Chưa sử dụng',
  [USER_GIFT_STATUS.USED]: 'Đã sử dụng',
  [USER_GIFT_STATUS.DELIVERED]: 'Đã giao',
  [USER_GIFT_STATUS.RECEIVED]: 'Đã nhận',
  [USER_GIFT_STATUS.EXPIRED]: 'Hết hạn',
};

export const USER_GIFT_STATUS_OPTIONS = Object.values(USER_GIFT_STATUS).map((value) => ({
  value,
  label: USER_GIFT_STATUS_LABEL[value],
}));

export const getUserGiftStatusLabel = (status) => (
  USER_GIFT_STATUS_LABEL[status] || status
);

export default {
  async getGifts(payload) {
    const params = getParamsFormObject(payload);
    const path = `${giftsEndPoint}${params}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async getGiftDetails(id) {
    const path = `${giftsEndPoint}/${id}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async createGift(payload) {
    const response = await axiosClient.post(giftsEndPoint, payload);
    return response.data;
  },

  async getUserGifts(payload) {
    const params = getParamsFormObject(payload);
    const path = `${userGiftsEndPoint}${params}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async getUserGiftDetails(id) {
    const path = `${userGiftsEndPoint}/${id}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async updateGift(id, payload) {
    const path = `${giftsEndPoint}/${id}`;
    const response = await axiosClient.put(path, payload);
    return response.data;
  },

  async deleteGift(id) {
    const path = `${giftsEndPoint}/${id}`;
    const response = await axiosClient.delete(path);
    return response.data;
  },

  async updateUserGift(id, payload) {
    const path = `${userGiftsEndPoint}/${id}`;
    const response = await axiosClient.put(path, payload);
    return response.data;
  },

  async updateUserGiftStatus(id, payload) {
    const path = `${userGiftsEndPoint}/${id}/status`;
    const response = await axiosClient.put(path, payload);
    return response.data;
  },
};
